import { useEffect } from "react";
import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";

const defaultLng = "nl";

const syncLanguageFromStorage = () => {
  const stored = localStorage.getItem("language");
  if (stored && stored !== i18n.language) {
    i18n.changeLanguage(stored);
  }
};

window.addEventListener("focus", syncLanguageFromStorage);

i18n.on("initialized", () => {
  if (!localStorage.getItem("language")) {
    localStorage.setItem("language", defaultLng);
  }
});

export const useFixedT = (lng: "nl" | "en" | "tr") => {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    const defaultNS = i18nInstance.options.defaultNS || "translation";

    if (!i18nInstance.hasResourceBundle(lng, defaultNS)) {
      i18nInstance.loadLanguages(lng).catch((error) => {
        console.error("Failed to load fixed translation language:", lng, error);
      });
    }
  }, [i18nInstance, lng]);

  return i18nInstance.getFixedT(lng);
};
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
});

i18n
  .use(initReactI18next)
  .use(
    resourcesToBackend((language) => {
      return import(`./shared/translations/${language}.json`);
    })
  )
  .init({
    supportedLngs: [
      "nl",
      "en",
      "tr",
      "ar",
      "es",
      "de",
      "fr",
      "pl",
      "ru",
      "zh",
      "it",
      "pa",
      "hi",
      "ur",
      "sr",
      "ja",
      "ko",
    ],
    preload: ["nl", "en"],
    // Only load the exact locale file (e.g. zh.json). Default "all" also
    // requests "zh", which has no translation file and breaks Chinese.
    load: "currentOnly",
    nonExplicitSupportedLngs: true,
    lng: localStorage.getItem("language"), // if you're using a language detector, do not define the lng option
    fallbackLng: defaultLng,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
